import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ImageInfo } from 'src/app/model/model';

@Component({
  selector: 'app-image-carousel',
  templateUrl: './image-carousel.component.html',
  styleUrls: ['./image-carousel.component.css']
})
export class ImageCarouselComponent implements OnInit {
  @Input() images: ImageInfo[] = []
  @Input() currentIdx = 0

  @Output() currentIdxEvent = new EventEmitter<number>();

  currentImage = ''
  currentCaption = ''

  constructor() { }

  ngOnInit(): void {
    this.currentImage = this.images[this.currentIdx].imagePath
    this.currentCaption = this.images[this.currentIdx].caption
    this.currentIdxEvent.emit(this.currentIdx);
  }

  goAhead() {
    this.currentIdx = (this.currentIdx + 1) % this.images.length
    this.currentImage = this.images[this.currentIdx].imagePath
    this.currentCaption = this.images[this.currentIdx].caption
    this.currentIdxEvent.emit(this.currentIdx);
  }

  goBack() {
    this.currentIdx = (this.currentIdx - 1) % this.images.length
    if (this.currentIdx < 0)
      this.currentIdx = this.images.length - 1

    this.currentImage = this.images[this.currentIdx].imagePath
    this.currentCaption = this.images[this.currentIdx].caption
    this.currentIdxEvent.emit(this.currentIdx);
  }
}
